
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.216 18.006c-.803 0-1.517-.133-2.14-.4a4.545 4.545 0 01-1.54-1.071 4.92 4.92 0 01-.958-1.621 6.334 6.334 0 01-.312-1.995c0-.216.007-.407.022-.573.03-.167.06-.325.09-.474h-.571a1.035 1.035 0 010-2.07h1.485l3.12-1.895H3.82a1.047 1.047 0 010-2.094h7.069a2.77 2.77 0 00.134-.923c0-.781-.194-1.346-.58-1.695-.372-.35-.9-.524-1.583-.524a3.39 3.39 0 00-1.664.416c-.703.388-1.659.405-2.14-.236-.334-.445-.338-1.07.077-1.44a5.372 5.372 0 011.319-.86A6.112 6.112 0 019.015.004c.728 0 1.382.125 1.962.374.58.233 1.07.557 1.471.972.402.4.707.881.915 1.447a4.65 4.65 0 01.334 1.77c0 .432-.045.848-.134 1.247h.625a1.047 1.047 0 010 2.094h-1.65L9.483 9.802h4.718a1.035 1.035 0 110 2.07H7.075c-.089.282-.134.59-.134.922 0 .865.209 1.513.625 1.945.43.432 1.025.648 1.783.648a3.227 3.227 0 002.031-.71c.649-.494 1.602-.49 2.092.161.344.457.35 1.098-.064 1.494a6.637 6.637 0 01-1.405 1.025c-.818.433-1.747.649-2.787.649z"}})])
          )
        }
      }
    